// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'issued-loan-payment.page.title': 'Issued Loan Payments',
    'issued-loan-payment.page.search_results': 'Search Results',
    'issued-loan-payment.page.create.title': 'New Loan Payment',
    'issued-loan-payment.page.search.title': 'Find Loan Payments',
    'issued-loan-payment.page.title.redo': 'Redo Payment',
    'issued-loan-payment.page.view.title': 'View Loan Payment',
    'issued-loan-payment.page.all': 'All',

    'issued-loan-payment.button.cancel': 'Cancel',
    'issued-loan-payment.button.select': 'Select',
    'issued-loan-payment.button.find': 'Find Loan Payments',
    'issued-loan-payment.button.search': 'Apply',
    'issued-loan-payment.button.create': 'Record Payment',
    'issued-loan-payment.button.new': 'New Loan Payment',
    'issued-loan-payment.button.save': 'Save Changes',
    'issued-loan-payment.button.edit': 'Edit',
    'issued-loan-payment.button.restore': 'Restore',
    'issued-loan-payment.button.reset': 'Reset',
    'issued-loan-payment.button.payments': 'Payment History',
    'issued-loan-payment.button.void': 'Void Payment',
    'issued-loan-payment.button.rollback': 'Rollback Payment',
    'issued-loan-payment.button.redo': 'Redo',

    'issued-loan-payment.placeholder.search': 'Search issued loan payments',

    'issued-loan-payment.message.no_payment': 'No payment has been recorded as yet.',
    'issued-loan-payment.message.overpayment': 'Remember to adjust the balance outstanding with any additional interest and penalty on the loan',

    'issued-loan-payment.link.create_first_issued_loan_payment': 'Click here to create your first issued loan payment',
    'issued-loan-payment.link.issued_loan_payments': ' Return to Issued Loan Payments',
    'issued-loan-payment.link.retry': 'Click here to retry',

    'issued-loan-payment.checkbox.all': 'Check All',
    'issued-loan-payment.checkbox.actions_label': 'with selected',

    'issued-loan-payment.label.issued_loan_name': 'Issued Loan',
    'issued-loan-payment.label.transaction_date': 'Transaction Date',
    'issued-loan-payment.label.bank_general_ledger_account_name': 'Bank Account',
    'issued-loan-payment.label.transaction_number': 'Transaction Number',
    'issued-loan-payment.label.is_reconciled': 'Is Reconciled',
    'issued-loan-payment.label.payment_method': 'Payment Method',
    'issued-loan-payment.label.reference_code': 'Reference Code',
    'issued-loan-payment.label.memo': 'Memo',
    'issued-loan-payment.label.currency_name': 'Currency',
    'issued-loan-payment.label.currency_principal_amount_in_cents': 'Principal Amount',
    'issued-loan-payment.label.currency_interest_amount_in_cents': 'Interest Amount',
    'issued-loan-payment.label.currency_grand_total_in_cents': 'Grand Total',
    'issued-loan-payment.label.cancelled_on': 'Cancelled On',
    'issued-loan-payment.label.cancellation_reason': 'Cancellation Reason',
    'issued-loan-payment.label.issued_loan_payment_status': 'Issued Loan Payment Status',
    'issued-loan-payment.label.reason_for_void': 'Reason for voiding',
    'issued-loan-payment.label.rollback_reason': 'Reason for rollback',
    'issued-loan-payment.label.issue_credit_memo': 'Give store credit?',
    'issued-loan-payment.label.status': 'Status',
    'issued-loan-payment.label.use_credit': 'Use Available Credit',

    'issued-loan-payment.sort.field_label': 'Field',
    'issued-loan-payment.sort.direction_label': 'Direction',
    'issued-loan-payment.sort.direction_ascending': 'Ascending',
    'issued-loan-payment.sort.direction_descending': 'Descending',

    'issued-loan-payment.modal.title.issued_loan_payment_void': 'Void Payment',
    'issued-loan-payment.modal.title.issued_loan_payment_rollback': 'Rollback Payment',
    'issued-loan-payment.modal.title.overpayment': 'Overpayment',

    'issued-loan-payment.modal.message.overpayment': 'Payment is more than the amount outstanding, please review the amount due or adjust the amount outstanding by {amount} to reflect the new balance.',

    'issued-loan-payment.success.message.issued_loan_payment_created': 'Your loan payment has been created',
    'issued-loan-payment.success.message.issued_loan_payment_updated': 'Your loan payment has been updated',
    'issued-loan-payment.success.message.issued_loan_payment_voided': 'Your loan payment has been voided',
    'issued-loan-payment.success.message.issued_loan_payment_rolled_back': 'Your loan payment has been rolled back',
    'issued-loan-payment.success.message.issued_loan_payment_redone': 'Your loan payment has been redone',

    'issued-loan-payment.error.message.error_loading_page': 'Sorry, there was an error loading issued loan payment.| Sorry, there was an error loading issued loan payments.',
};
